export const HOME = '/';
export const PORTAL = '/portal/:key';

export const LOGIN_TOKEN = '/auth';